import { SealCheck, Star, Leaf } from "@phosphor-icons/react";
import { COMPANY } from "../data/site";
import { Reveal } from "./Reveal";

// Trust strip: RGE · MaPrimeRénov/CEE · Google rating
export default function TrustBanner() {
  const items = [
    { icon: SealCheck, title: "Artisan RGE", sub: "Certifié Qualit'EnR", color: "#FC8529" },
    { icon: Leaf, title: "MaPrimeRénov' & CEE", sub: "Aides à la rénovation", color: "#1A49F7" },
    { icon: Star, title: `${COMPANY.rating} sur Google`, sub: `${COMPANY.reviewsCount} avis clients`, color: "#FF3123" },
  ];
  return (
    <section data-testid="trust-banner" className="border-y border-[#F0F0F0] bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 divide-y divide-[#F0F0F0] px-6 md:grid-cols-3 md:divide-x md:divide-y-0 md:px-12">
        {items.map((it, i) => (
          <Reveal key={it.title} delay={i * 0.1}>
            <div className="flex items-center gap-4 py-8 md:px-8">
              <it.icon weight="light" className="h-9 w-9 shrink-0" style={{ color: it.color }} />
              <div>
                <p className="text-base font-semibold leading-tight">{it.title}</p>
                <p className="text-sm text-[#888]">{it.sub}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
